const googleMaps = {
  apiKey:
    process.env.GOOGLE_MAPS_API_KEY ||
    'AIzaSyBN3uTF9NjptxEwR9swpQFn6LRZpiqsC04',
};

export const env = {
  googleMaps,
};
